import { pipe, map, trim, split } from 'ramda'

const readFileAsText = async file => {
  const reader = new window.FileReader()
  return new Promise((resolve, reject) => {
    reader.onload = () => {
      resolve(pipe(split('\n'), map(trim))(reader.result))
    }
    reader.readAsText(file)
  })
}

export default { readFileAsText }



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-unique-codes/readFile.js